// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#mathfield[data-v-6256b050] math-field{width:\"auto\";position:relative;font-size:16px;z-index:1;border-radius:4px;padding:8px;text-align:center}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
